import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import './sessionTimer.scss'
import { styled, useTheme } from "@mui/material/styles";

const SessionTimer = ({ hours, minutes, seconds }) => {
  const [time, setTime] = useState({
    hours: parseInt(hours, 10),
    minutes: parseInt(minutes, 10),
    seconds: parseInt(seconds, 10),
  });


  useEffect(() => {
    const timerId = setInterval(() => {
      setTime((prevTime) => {
        let { hours, minutes, seconds } = prevTime;

        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          clearInterval(timerId);
        }

        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [time]);

  const formatTime = (value) => (value < 10 ? `0${value}` : value);
  const theme = useTheme();
  return (
    <Box className="session-timer" sx={{color:theme.palette.customColor.textDark}}>
       <Typography component={'span'} variant='span' className='timerBlk'> {formatTime(time.hours)}</Typography>:<Typography component={'span'} variant='span' className='timerBlk'>{formatTime(time.minutes)}</Typography>:<Typography component={'span'} variant='span' className='timerBlk'>{formatTime(time.seconds)}</Typography>
    </Box>
  );
};

export default SessionTimer;
